// extracted by mini-css-extract-plugin
export default {"wrapperModal":"Modal_wrapperModal__IGiw0","title":"Modal_title__GEAWO","description":"Modal_description__1JqVl"};